module.exports = __webpack_public_path__ + "img/aurora-mobile.de764a2d.webp";